import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import Visa from "../../images/Visa.svg"
import Visa_title from "../../images/Visa_title.svg"
import Maestro from "../../images/Maestro.svg"
import Mastercard from "../../images/Mastercard.svg"
import Affirm_Logo from "../../images/Affirm_Logo.svg"
import { Image, Input, Form, Button, Popup } from "semantic-ui-react"
import LockIcon from "../../images/LockIcon.svg"
import ShieldIcon from "../../images/ShieldIcon.svg"
import Mastercard_title from "../../images/Mastercard_title.svg"
import AmericanExpress from "../../images/AmericanExpress.svg"
import AddCardIcon from "../../images/AddCardIcon.svg"
import DeleteIcon from "../../images/delete_icon_vector.svg"
import { connect } from "react-redux"
import {
  createPaymentMethod,
  getBraintreePaymentToken,
  setDefaultPaymentCard,
  removePaymentCard,
  getPaymentCards
} from "../actions/paymentMethods"
import braintree from "braintree-web"
import ShimmerSquar from "./ShimmerSquar"
import {
  MASTERCARD,
  VISA,
  TIRES,
  ADD_NEW_BRAINTREE_CARD_URL,
  AFFIRM,
  PAYPAL,
  BRAINTREE,
  PAYPAL_ACCOUNT
} from "../constants/tires"
import Notifications from "../components/Notifications"
import store from "../../shared_component/utils/configureStore"
import CrossIcon from "../../images/btn-delete.png"
import Cvv_info from "../../images/Cvv_Info.png"
import { prepareCheckoutObj, prepareTireCheckoutObj } from "../helpers/affirmHelper"
import { setupPaypalBraintree } from "../../shared_component/utils/setupBraintree"
import { NoChargeBanner } from "../../shared_component/elements/NoChargeBanner"
import { PAYMENT_METHODS, USD_CURRENCY } from "../constants/application"
import ReactSVG from "react-svg"
import { trackEvent } from "../../shared_component/utils/segmentAnalytics"
import RewardMilesPayment from "../../v2/components/Rewards/RewardMilesPayment"
import zipcodes from "zipcodes"
import { isEmpty } from "lodash"
import { getUpdatedCart } from "../helpers/orderHelpers"

function TirePaymentLoading({ parentClassName, showBtnShimmer, addNewCardBtn }) {
  const shimmerCards = Array.from({ length: 4 }, (_, index) => {
    return <div className="paypal-btn-loading cards-shimmer-effect"></div>
  })

  return (
    <div className="shimmer-parent-width">
      <div className={`${parentClassName}`}>{shimmerCards}</div>
      {showBtnShimmer ? (
        <>
          <br />
          <ShimmerSquar containerClass="h-[25px]" height={20} className="w-2" />
          <br />
          <div className="cards-parent row">
            <div className="paypal-btn-loading btns-shimmer-effect"></div>
            <div className="paypal-btn-loading btns-shimmer-effect"></div>
          </div>
          <ShimmerSquar containerClass="h-[25px]" height={20} className="w-2" />
        </>
      ) : null}
      {addNewCardBtn ? (
        <ShimmerSquar containerClass="h-[25px]" height={50} className="w-2 add-new-card-shimmer" />
      ) : null}
    </div>
  )
}

function AddNewCardShimmer() {
  return (
    <div className="add-card-parent-shimmer">
      <div className="label-shimmer">
        <ShimmerSquar containerClass="h-[25px]" height={20} className="w-2 span-shimmer" />
        <ShimmerSquar containerClass="h-[25px]" height={20} className="w-2 span-shimmer" />
      </div>
      <ShimmerSquar containerClass="h-[25px]" height={40} className="w-2" />
      <ShimmerSquar containerClass="h-[25px]" height={20} className="w-2" />
      <ShimmerSquar containerClass="h-[25px]" height={40} className="w-2" />
      <div className="security-parent-shimmer">
        <ShimmerSquar
          containerClass="h-[25px]"
          height={20}
          className="w-2 security-input-shimmer"
        />
        <ShimmerSquar
          containerClass="h-[25px]"
          height={20}
          className="w-2 security-input-shimmer"
        />
      </div>
      <ShimmerSquar containerClass="h-[25px]" height={20} className="w-2" />
      <ShimmerSquar containerClass="h-[25px]" height={60} className="w-2" />
    </div>
  )
}

function TirePayment({
  t,
  has_cc_info_saved,
  user,
  braintreePaymentMethods,
  getBraintreePaymentToken,
  createPaymentMethod,
  setPaymentCard,
  setDefaultPaymentCard,
  getPaymentCards,
  removePaymentCard,
  module,
  bookingDetails,
  totalAmountDue,
  shopDetails,
  setPaymentMethod,
  paymentMethod,
  showNoChargeBanner,
  navOpen,
  anyOrderServiceLackPrice
}) {
  const [isCardAvailable, setIsCardAvailable] = useState(false)
  const [openAddNewModal, setOpenAddNewModal] = useState(false)
  const [headerText, setHeaderText] = useState()
  const [selectedCard, setSelectedCard] = useState()
  const [clientToken, setClientToken] = useState()
  const [cardNumber, setCardNumber] = useState()
  const [nameOnCard, setNameOnCard] = useState()
  const [cvv, setCvv] = useState()
  const [expirationDate, setExpirationDate] = useState()
  const [isPrimaryCard, setIsPrimaryCard] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [openEditCardsModal, setOpenEditCardsModal] = useState(false)
  const [showCvvInfo, setShowCvvInfo] = useState(false)
  const [isAddCardBtnDisabled, setIsAddCardBtnDisabled] = useState(true)
  const [cardNumberClone, setCardNumberClone] = useState("")
  const [showExpiryErrorMsg, setShowExpiryErrorMsg] = useState(false)
  const [affirmCheckoutLoading, setAffirmCheckoutLoading] = useState(false)
  const [isPaypalLoading, setIsPaypalLoading] = useState(true)
  const [isExpiryDateChanged, setIsExpiryDateChanged] = useState(false)
  const [paypalMethodElement, setPaypalMethodElement] = useState("")
  const [paypalNonce, setPaypalNonce] = useState("")
  const [previousLength, setPreviousLength] = useState(
    braintreePaymentMethods && braintreePaymentMethods.length
  )
  const [zipCode, setZipCode] = useState()

  const handleClose = (e) => {
    setOpenAddNewModal(false)
    setCardNumber()
    setNameOnCard()
    setCvv()
    setExpirationDate()
    setIsPrimaryCard(false)
    setZipCode()
  }

  const handleOpen = (e) => {
    handleCloseEditCardsModal()
    setOpenAddNewModal(true)
  }

  useEffect(() => {
    setSelectedCard()
    getSavedCardDetails()
    if (has_cc_info_saved && braintreePaymentMethods && braintreePaymentMethods.length > 0) {
      setIsCardAvailable(true)
    }
  }, [])

  const handlePaypalMethodBorder = (paymentType = PAYPAL) => {
    const methodsContainer = document.querySelector(
      '[data-braintree-id="methods-container"] > div:first-child'
    )
    if (paymentType === PAYPAL && methodsContainer) {
      methodsContainer.classList.add("custom-paypal-border")
    } else if (methodsContainer && paymentType === BRAINTREE) {
      methodsContainer.classList.remove("custom-paypal-border")
    }
  }

  useEffect(() => {
    if (paypalMethodElement && module === TIRES) {
      handlePaypalMethodBorder()
      paypalMethodElement.addEventListener("click", () => {
        handlePaypalMethodBorder()
        setPaymentMethod(PAYPAL)
        setPaymentCard(paypalNonce)
        setSelectedCard()
      })
    }
  }, [paypalMethodElement])

  useEffect(() => {
    if (braintreePaymentMethods && braintreePaymentMethods.length !== previousLength) {
      setSelectedCard()
      getSavedCardDetails()
      if (has_cc_info_saved && braintreePaymentMethods && braintreePaymentMethods.length > 0) {
        setIsCardAvailable(true)
      }
      setPreviousLength(braintreePaymentMethods.length)
    }
  }, [braintreePaymentMethods, has_cc_info_saved, previousLength])

  const onCardChange = (e, card) => {
    if (module === TIRES) {
      handlePaypalMethodBorder(BRAINTREE)
    }
    setSelectedCard(card.token)
    setPaymentCard(module === TIRES ? card.token : card)
    setPaymentMethod(BRAINTREE)
    trackEvent("select-payment-method", {
      eventSourceName: "Checkout_2.0"
    })
  }

  const getSavedCardDetails = async () => {
    if (has_cc_info_saved && braintreePaymentMethods && braintreePaymentMethods.length > 0) {
      let defaultSelected =
        braintreePaymentMethods.filter((i) => i.isdefault).length > 0
          ? braintreePaymentMethods.filter((i) => i.isdefault)[0].token
          : braintreePaymentMethods[0].token

      let selected =
        braintreePaymentMethods.filter((i) => i.isdefault).length > 0
          ? braintreePaymentMethods.filter((i) => i.isdefault)[0]
          : braintreePaymentMethods[0]
      setSelectedCard(defaultSelected)
      await setPaymentMethod(BRAINTREE)
      await setPaymentCard(module === TIRES ? defaultSelected : selected)
      setHeaderText(braintreePaymentMethods.length + t("saved_card"))
    } else {
      setHeaderText(t("Pay_by_card"))
      setPaymentCard()
      const response = await getPaymentCards(user)
      if (response.result && response.result.length > 0) {
        let cardToken =
          response.result.filter((i) => i.isdefault).length > 0
            ? response.result.filter((i) => i.isdefault)[0].token
            : response.result[0].token

        let card =
          response.result.filter((i) => i.isdefault).length > 0
            ? response.result.filter((i) => i.isdefault)[0]
            : response.result[0]
        setPaymentMethod(BRAINTREE)
        setPaymentCard(module === TIRES ? cardToken : card)
      }
    }
  }

  useEffect(() => {
    if (module === TIRES && totalAmountDue) setupData()
    else if (module !== TIRES) setupData()
    getPaymentToken()
  }, [totalAmountDue])

  const getPaymentToken = async () => {
    const tokenResponse = await getBraintreePaymentToken(user)
    setClientToken(tokenResponse && tokenResponse.result && tokenResponse.result.client_token)
  }

  useEffect(() => {
    if (
      !cardNumber ||
      cardNumber === "" ||
      !nameOnCard ||
      nameOnCard === "" ||
      !cvv ||
      cvv === "" ||
      !expirationDate ||
      expirationDate === "" ||
      expirationDate.length < 5 ||
      !validateExpiryDate(expirationDate) ||
      !zipCode ||
      zipCode === "" ||
      zipCode.length < 5 ||
      !validateValidZip(zipCode)
    ) {
      setIsAddCardBtnDisabled(true)
    } else {
      setIsAddCardBtnDisabled(false)
    }
  }, [cardNumber, nameOnCard, cvv, expirationDate, zipCode])

  useEffect(() => {
    if (showExpiryErrorMsg) {
      store.dispatch(
        Notifications.error({
          title: t("Error"),
          message: t("Enter_expiry_date_from_future"),
          position: "tr",
          autoDismiss: 3,
          action: {
            label: "Dismiss"
          }
        })
      )
    }
  }, [showExpiryErrorMsg, isExpiryDateChanged])

  const addNewCard = () => {
    setOpenEditCardsModal(false)
    if (isAddCardBtnDisabled) {
      store.dispatch(
        Notifications.error({
          title: t("Error"),
          message: t("Enter_all_details"),
          position: "tr",
          autoDismiss: 2,
          action: {
            label: "Dismiss"
          }
        })
      )
    } else {
      setIsLoading(true)

      let trimmedCardNumber = cardNumberClone.replace(/\s/g, "")

      braintree.client.create(
        {
          authorization: clientToken
        },
        function (err, client) {
          let creditcardObj = {
            number: trimmedCardNumber,
            expirationDate: expirationDate,
            cvv: cvv,
            cardholderName: nameOnCard
          }
          if (user && user.zip) {
            creditcardObj = {
              ...creditcardObj,
              billingAddress: {
                postalCode: zipCode || (user && user.zip)
              }
            }
          }
          client.request(
            {
              endpoint: ADD_NEW_BRAINTREE_CARD_URL,
              method: "post",
              data: {
                creditCard: creditcardObj
              }
            },
            async function (err, response) {
              if (response) {
                handleClose()
                const res = await createPaymentMethod(user, response.creditCards[0].nonce)
                if (res) {
                  if (isPrimaryCard) {
                    await handleSetDefault(res.result[0])
                  }
                  setCardNumber("")
                  setCardNumberClone("")
                }
              } else if (err) {
                store.dispatch(
                  Notifications.error({
                    title: t("Error"),
                    message:
                      err &&
                      err.details &&
                      err.details.originalError &&
                      err.details.originalError.error &&
                      err.details.originalError.error.message,
                    position: "tr",
                    autoDismiss: 5,
                    action: {
                      label: "Dismiss"
                    }
                  })
                )
              }
              setIsLoading(false)
            }
          )
        }
      )
    }
  }

  const handleCardNumberBlur = () => {
    if (cardNumber && cardNumber.length === 19) {
      setCardNumberClone(cardNumber)
      const maskedCardNumber = "•".repeat(12) + cardNumber.replace(/\s/g, "").slice(12) // Remove spaces before replacing
      const finalFormattedCardNumber = maskedCardNumber.replace(/(•{4})/g, "$1 ").trim() // Add spaces after every 4 digits
      setCardNumber(finalFormattedCardNumber)
    }
  }

  const handleCardNumberFocus = () => {
    if (cardNumber) {
      setCardNumber(cardNumberClone)
    }
  }

  const handleCardNumberChange = (event) => {
    const inputCardNumber = event.target.value
    const regex = /^[0-9\s]*$/

    if (regex.test(inputCardNumber)) {
      const formattedCardNumber = inputCardNumber
        .replace(/\s/g, "")
        .replace(/(\d{4})/g, "$1 ")
        .trim()

      const isValid = formattedCardNumber.replace(/\s/g, "").length <= 16

      if (isValid) {
        setCardNumber(formattedCardNumber)
      }
    } else {
      setCardNumber(cardNumber || "")
    }
  }

  const handleIsPrimaryBtnClick = () => {
    setIsPrimaryCard(!isPrimaryCard)
  }

  const handleRemoveCard = async (e, card) => {
    setIsLoading(true)
    const response = await removePaymentCard(user, card.token)
    if (response && response.result) {
      store.dispatch(
        Notifications.success({
          title: t("Card_removed"),
          position: "tr",
          autoDismiss: 2,
          action: {
            label: "Dismiss"
          }
        })
      )
    } else {
      store.dispatch(
        Notifications.error({
          title: t("Error"),
          message: t("Card_deletion_failed"),
          position: "tr",
          autoDismiss: 2,
          action: {
            label: "Dismiss"
          }
        })
      )
    }
    setIsLoading(false)
  }

  const handleSetDefault = async (card) => {
    if (card.isdefault) return false
    setIsLoading(true)
    const response = await setDefaultPaymentCard(user, card.token)
    if (response && response.result) {
      setSelectedCard(card.token)
      store.dispatch(
        Notifications.success({
          title: t("Default_card_updated"),
          position: "tr",
          autoDismiss: 2,
          action: {
            label: "Dismiss"
          }
        })
      )
    } else {
      store.dispatch(
        Notifications.error({
          title: t("Error"),
          message: t("Default_card_update_failed"),
          position: "tr",
          autoDismiss: 2,
          action: {
            label: "Dismiss"
          }
        })
      )
    }
    setIsLoading(false)
  }

  const validateExpiryDate = (dateToCheck) => {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear() % 100
    const currentMonth = currentDate.getMonth() + 1

    const [inputMonth, inputYear] = dateToCheck.split("/").map(Number)

    if (
      inputMonth <= 12 &&
      (inputYear > currentYear || (inputYear === currentYear && inputMonth >= currentMonth))
    ) {
      setShowExpiryErrorMsg(false)
      return true
    } else {
      setShowExpiryErrorMsg(true)
      return false
    }
  }

  const handleExpirationDateChange = (event) => {
    const input = event.target.value
      .replace(/^([1-9]\/|[2-9])$/g, "0$1/")
      .replace(/^(0[1-9]|1[0-2])$/g, "$1/")
      .replace(/^([0-1])([3-9])$/g, "0$1/$2")
      .replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, "$1/$2")
      .replace(/^([0]+)\/|[0]+$/g, "0")
      .replace(/[^\d\/]|^[\/]*$/g, "")

    const formattedInput = input.replace(/[^\d]/g, "")

    const isValid = /^\d{0,2}\/?\d{0,2}$/.test(formattedInput)

    if (isValid) {
      let updatedInput = formattedInput
      if (formattedInput.length > 2) {
        updatedInput = `${formattedInput.slice(0, 2)}/${formattedInput.slice(2)}`
      }
      setExpirationDate(updatedInput)

      if (updatedInput.length === 5) {
        validateExpiryDate(updatedInput)
        setIsExpiryDateChanged(!isExpiryDateChanged)
      }
    }
  }

  const handleCvvChange = (e) => {
    const re = /^[0-9\b]+$/
    if (e.target.value === "" || re.test(e.target.value)) {
      setCvv(e.target.value)
    } else {
      setCvv(cvv ? cvv : "")
    }
  }

  const handleZipCodeChange = (e) => {
    const re = /^[0-9\b]+$/
    if (e.target.value === "" || re.test(e.target.value)) {
      setZipCode(e.target.value)
    } else {
      setZipCode(zipCode ? zipCode : "")
    }
  }

  const validateValidZip = (value) => {
    const result = zipcodes.lookup(value)
    return result !== undefined
  }

  const handleOpenEditCardsModal = () => {
    setOpenEditCardsModal(true)
  }

  const handleCloseEditCardsModal = () => {
    setOpenEditCardsModal(false)
  }

  const openCvvInfo = () => {
    setShowCvvInfo(true)
  }

  const closeCvvInfo = () => {
    setShowCvvInfo(false)
  }

  const handleNameOnCard = (e) => {
    const regex = /^[A-Za-z\s]*$/
    const value = e.target.value

    if (regex.test(value)) {
      setNameOnCard(value)
    } else {
      setNameOnCard(nameOnCard || "")
    }
  }

  const handleAffirmPayment = async (e) => {
    if (user && user.generic) {
      return
    }
    setAffirmCheckoutLoading(true)
    let checkoutObj =
      module === TIRES
        ? prepareTireCheckoutObj(user, bookingDetails, totalAmountDue, shopDetails)
        : prepareCheckoutObj(user, bookingDetails)
    window.affirm.checkout(checkoutObj)

    await window.affirm.checkout.open({
      onFail: (a) => onFailedCheckout(a),
      onSuccess: (a) => onSuccessCheckout(a)
    })
    if (e) e.preventDefault()
  }

  const onFailedCheckout = (obj) => {
    window.affirm.ui.refresh()
    getSavedCardDetails()
    setAffirmCheckoutLoading(false)
    setupData()
  }

  const onSuccessCheckout = (obj) => {
    let affirmCheckoutToken = obj["checkout_token"]
    if (affirmCheckoutToken) {
      setPaymentCard(affirmCheckoutToken)
      setPaymentMethod(AFFIRM)
      setSelectedCard()
      setupData()
    }
    window.affirm.ui.refresh()
    setAffirmCheckoutLoading(false)
  }

  const setupData = async () => {
    setIsPaypalLoading(true)
    let btInstance = await setupPaypalBraintree({
      authentication_token: user.authentication_token,
      div: "#paypal-custom-btn",
      amount: totalAmountDue
    })
    if (btInstance) {
      btInstance.on("paymentMethodRequestable", async (event) => {
        try {
          const paymentMethod = await btInstance.requestPaymentMethod()
          if (paymentMethod.type === PAYPAL_ACCOUNT) {
            const { nonce } = paymentMethod
            if (nonce) {
              setPaymentCard(module === TIRES ? nonce : paymentMethod)
              setPaymentMethod(PAYPAL)
              setSelectedCard()
            }

            if (module === TIRES) {
              setPaypalNonce(nonce)
              const paypalPaymentMethod = document.querySelector(".braintree-method--active")
              setPaypalMethodElement(paypalPaymentMethod)
            }
          }
        } catch (error) {
          console.log(error)
        }
      })
    }
    setIsPaypalLoading(false)
  }

  let orderPrice, orderCurrency, order_previous_payments, remaining_payment

  if (bookingDetails) {
    orderPrice = bookingDetails.estimated_total
    orderCurrency = bookingDetails.currency
    order_previous_payments = 0.0
  }

  remaining_payment = orderPrice - order_previous_payments

  const showAffirm =
    remaining_payment === 0.0 ||
    (remaining_payment !== 0.0 && remaining_payment < 50) ||
    orderCurrency !== USD_CURRENCY ||
    (bookingDetails.any_order_service_lacks_price &&
      bookingDetails.any_order_service_lacks_price) ||
    bookingDetails.estimated_total < 50

  const isRewardsFeature =
    window.splitClientFlagCache && window.splitClientFlagCache.isRewardsFeature

  const isOrderExists =
    user.active_orders && user.active_orders.length && user.active_orders.length > 0
      ? user.active_orders.find((order) => {
          if (+order.vehicle_id === +user.activeVehicleId) {
            return order
          }
        })
      : {}

  return (
    <>
      <div className="pay-card">
        <div className="booking-heading">
          {!isCardAvailable ? t("Complete_your_booking") : t("Select_payment_method")}
        </div>
        {isCardAvailable && showNoChargeBanner && module !== TIRES ? <NoChargeBanner /> : null}
        {isEmpty(isOrderExists) &&
          module !== TIRES &&
          isRewardsFeature &&
          !user.generic &&
          !anyOrderServiceLackPrice && <RewardMilesPayment />}
        <div className="outerDiv">
          <div className="leftDiv">
            {headerText}
            {braintreePaymentMethods && braintreePaymentMethods.length > 0 ? (
              <p className="edit-card-btn" onClick={handleOpenEditCardsModal}>
                {t("Edit_cards")}
              </p>
            ) : null}
          </div>
          <div className="rightDiv">
            <Image src={Visa} />
            <Image src={Maestro} />
            <Image src={Mastercard} />
          </div>
        </div>
        <div className="form-parent">
          {affirmCheckoutLoading ? (
            <TirePaymentLoading
              parentClassName="cards-parent"
              showBtnShimmer={true}
              addNewCardBtn={false}
            />
          ) : (
            <Form>
              {!isCardAvailable ? (
                !isLoading ? (
                  <div className="information-inputs">
                    <div className="input-parent" style={{ width: "99%" }}>
                      <label>{t("Card_Number")}</label>
                      <Input
                        type="text"
                        id="cardNumber"
                        value={cardNumber}
                        icon="credit card"
                        iconPosition="left"
                        placeholder="_ _ _ _-_ _ _ _-_ _ _ _-_ _ _ _"
                        onChange={handleCardNumberChange}
                        onBlur={handleCardNumberBlur}
                        onFocus={handleCardNumberFocus}
                        onPaste={(e) => {
                          e.preventDefault()
                          return false
                        }}
                        onCopy={(e) => {
                          e.preventDefault()
                          return false
                        }}
                      />
                    </div>
                    <div className="input-parent">
                      <label>{t("Name_on_card")}</label>
                      <Input
                        type="text"
                        placeholder={t("Name")}
                        onChange={handleNameOnCard}
                        value={nameOnCard}
                        onPaste={(e) => {
                          e.preventDefault()
                          return false
                        }}
                        onCopy={(e) => {
                          e.preventDefault()
                          return false
                        }}
                      />
                    </div>
                    <div className="input-parent">
                      <label>{t("Security_Code")}</label>
                      <Input
                        type="password"
                        placeholder="345"
                        autoComplete="new-password"
                        maxLength="4"
                        value={cvv}
                        onChange={handleCvvChange}
                        onPaste={(e) => {
                          e.preventDefault()
                          return false
                        }}
                        onCopy={(e) => {
                          e.preventDefault()
                          return false
                        }}
                      />
                    </div>
                    <div className="input-parent">
                      <label>{t("Expiration_Date")}</label>
                      <Input
                        type="text"
                        placeholder="MM/YY"
                        onChange={handleExpirationDateChange}
                        maxLength="5"
                        value={expirationDate}
                        onPaste={(e) => {
                          e.preventDefault()
                          return false
                        }}
                        onCopy={(e) => {
                          e.preventDefault()
                          return false
                        }}
                      />
                    </div>
                    <div className="input-parent">
                      <label>{t("Zip_Code")}</label>
                      <Input
                        type="text"
                        placeholder="Zip Code"
                        onChange={handleZipCodeChange}
                        maxLength="6"
                        value={zipCode}
                      />
                    </div>
                    <div className="input-parent ui checkbox" onClick={handleIsPrimaryBtnClick}>
                      <input type="checkbox" checked={isPrimaryCard} />
                      <label>{t("Make_primary_card")}</label>
                    </div>
                    <div className="input-parent" onClick={addNewCard}>
                      <button
                        className={`${!isAddCardBtnDisabled ? "active-btn" : ""}`}
                        disabled={isAddCardBtnDisabled}
                      >
                        {t("Add_card")}
                      </button>
                    </div>
                  </div>
                ) : (
                  <AddNewCardShimmer />
                )
              ) : !isLoading ? (
                <div className="cards-parent row">
                  {braintreePaymentMethods && braintreePaymentMethods.length > 0
                    ? braintreePaymentMethods.map((card) => {
                        const logo =
                          card.type === PAYMENT_METHODS.CREDIT_CARD
                            ? card.card_type
                            : PAYMENT_METHODS.PAYPAL
                        return (
                          <button
                            className={`card-btn card-btn-selected ${
                              selectedCard === card.token ? "default-card" : ""
                            } ${navOpen ? "custom-media" : ""}`}
                            onClick={(e) => onCardChange(e, card)}
                          >
                            <div className="card-details">
                              <ReactSVG
                                src={`images/paymentLogo/${logo.replace(/\s+/g, "")}.svg`}
                              />
                              <div>
                                {card.type === PAYMENT_METHODS.CREDIT_CARD ? (
                                  card.cardholder_name ? (
                                    <p className="card-details-name"> {card.cardholder_name} </p>
                                  ) : (
                                    <span>
                                      <p className="dot-input">{card.last_4}</p>&nbsp;
                                      {card.last_4}
                                    </span>
                                  )
                                ) : card.email ? (
                                  <p className="card-details-name"> {card.email} </p>
                                ) : (
                                  "--"
                                )}
                                {card.cardholder_name && (
                                  <span>
                                    <p className="dot-input">{card.last_4}</p>&nbsp;
                                    {card.last_4}
                                  </span>
                                )}
                              </div>
                            </div>
                            <input
                              type="radio"
                              name=""
                              id={card.token}
                              checked={selectedCard === card.token}
                            />
                          </button>
                        )
                      })
                    : null}
                </div>
              ) : (
                <TirePaymentLoading
                  parentClassName="cards-parent"
                  showBtnShimmer={false}
                  addNewCardBtn={false}
                />
              )}
              <p className="form-text">{t("Choose_payment_method")}</p>
              <div className="btn-parent row">
                <div
                  style={
                    remaining_payment == 0.0 ||
                    (bookingDetails && bookingDetails.any_order_service_lacks_price)
                      ? { pointerEvents: "none", opacity: "0.4" }
                      : {}
                  }
                  id="paypal-custom-btn"
                  className={`${
                    isPaypalLoading ? "display-none" : navOpen ? "payment-media-width" : ""
                  }`}
                ></div>
                {isPaypalLoading ? (
                  <button className="paypal-btn-loading btn-column"></button>
                ) : null}
                {isPaypalLoading ? (
                  <button className="paypal-btn-loading btn-column"></button>
                ) : (
                  <div
                    style={
                      showAffirm && module !== TIRES
                        ? { pointerEvents: "none", opacity: "0.4" }
                        : {}
                    }
                    className={`affirm-parent ${
                      paymentMethod === AFFIRM ? "affirm-active-payment-method" : ""
                    } ${navOpen ? "payment-media-width" : ""} ${
                      user && user.generic ? "black-white-container" : ""
                    }`}
                    onClick={handleAffirmPayment}
                  >
                    <button disabled={user && user.generic} className="affirm-btn btn-column">
                      <img src={Affirm_Logo} />
                      &nbsp;{t("Monthy_payments")}
                    </button>
                    <label className="affirm-label">{t("Starting_at")}</label>
                  </div>
                )}
              </div>
              <span>
                <img src={LockIcon} />
                {t("Payment_info_protected")}
              </span>
            </Form>
          )}
        </div>
      </div>
      {openAddNewModal ? (
        <div
          className="add-new-modal-backdrop"
          onClick={() => {
            handleClose()
          }}
        >
          <div
            className={`add-new-modal-content ${isLoading ? "add-new-modal-loading" : ""}`}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div className="card-modal-header">
              <h2>{t("Add_new_card")}</h2>
              <Image src={CrossIcon} className="cross-icon" onClick={handleClose} />
            </div>
            <hr />
            <div className="form-parent">
              {isLoading ? (
                <div className="loading-component-center">
                  <AddNewCardShimmer />
                </div>
              ) : (
                <Form>
                  <label>
                    <span>{t("Card_Number")}</span>
                    <div className="rightDiv">
                      <Image src={Visa} />
                      <Image src={Maestro} />
                      <Image src={Mastercard} />
                    </div>
                  </label>
                  <Input
                    type="text"
                    id="cardNumber"
                    value={cardNumber}
                    icon="credit card"
                    iconPosition="left"
                    placeholder="_ _ _ _-_ _ _ _-_ _ _ _-_ _ _ _"
                    onChange={handleCardNumberChange}
                    onBlur={handleCardNumberBlur}
                    onFocus={handleCardNumberFocus}
                    onPaste={(e) => {
                      e.preventDefault()
                      return false
                    }}
                    onCopy={(e) => {
                      e.preventDefault()
                      return false
                    }}
                  />
                  <label>{t("Name_on_card")}</label>
                  <Input
                    type="text"
                    placeholder={t("Name")}
                    value={nameOnCard}
                    onChange={handleNameOnCard}
                    onPaste={(e) => {
                      e.preventDefault()
                      return false
                    }}
                    onCopy={(e) => {
                      e.preventDefault()
                      return false
                    }}
                  />
                  <div className="security-inputs">
                    <div className="input-parent">
                      <label>{t("Security_Code")}</label>
                      <Input
                        type="password"
                        placeholder={t("digits_code")}
                        maxLength="4"
                        autoComplete="new-password"
                        value={cvv}
                        onChange={handleCvvChange}
                        onPaste={(e) => {
                          e.preventDefault()
                          return false
                        }}
                        onCopy={(e) => {
                          e.preventDefault()
                          return false
                        }}
                      />
                      <Popup
                        className="cvv-popup"
                        on="click"
                        pinned
                        open={showCvvInfo}
                        trigger={
                          <p className="require-text" onClick={openCvvInfo}>
                            {t("What_is_this")}
                          </p>
                        }
                      >
                        <div className="cvv-input-info">
                          <Image src={Cvv_info} />
                          <span>{t("Cvv_info")}</span>
                          <Image src={CrossIcon} className="cross-icon" onClick={closeCvvInfo} />
                        </div>
                      </Popup>
                    </div>
                    <div className="input-parent">
                      <label>{t("Expiration_Date")}</label>
                      <Input
                        type="text"
                        placeholder="MM/YY"
                        onChange={handleExpirationDateChange}
                        maxLength="5"
                        value={expirationDate}
                        onPaste={(e) => {
                          e.preventDefault()
                          return false
                        }}
                        onCopy={(e) => {
                          e.preventDefault()
                          return false
                        }}
                      />
                    </div>
                  </div>
                  <div className="security-inputs-zip">
                    <div className="input-parent">
                      <label>{t("Zip_Code")}</label>
                      <Input
                        type="text"
                        placeholder="Zip Code"
                        onChange={handleZipCodeChange}
                        maxLength="6"
                        value={zipCode}
                      />
                    </div>
                  </div>
                  <div className="make-primary-div ui checkbox" onClick={handleIsPrimaryBtnClick}>
                    <input type="checkbox" checked={isPrimaryCard} />
                    <label>{t("Make_primary_card")}</label>
                  </div>
                  <Button
                    className={`margin-bottom ${!isAddCardBtnDisabled ? "active-btn" : ""}`}
                    disabled={isAddCardBtnDisabled || isLoading}
                    onClick={addNewCard}
                  >
                    {t("Add_new_card")}
                  </Button>
                  <span className="payment-protected-info">
                    <img src={LockIcon} />
                    {t("Payment_info_protected")}
                  </span>
                </Form>
              )}
            </div>
          </div>
        </div>
      ) : null}
      {openEditCardsModal && braintreePaymentMethods && braintreePaymentMethods.length > 0 ? (
        <div
          className="edit-card-modal-backdrop"
          onClick={() => {
            handleCloseEditCardsModal()
          }}
        >
          <div
            className="edit-card-modal-content"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div className="edit-card-modal-header">
              <h2>{t("Saved_Cards")}</h2>
              <Image src={CrossIcon} onClick={handleCloseEditCardsModal} />
            </div>
            <hr />
            {!isLoading ? (
              <div className="edit-cards-parent row">
                {braintreePaymentMethods && braintreePaymentMethods.length > 0
                  ? braintreePaymentMethods.map((card) => {
                      const logo =
                        card.type === PAYMENT_METHODS.CREDIT_CARD
                          ? card.card_type
                          : PAYMENT_METHODS.PAYPAL
                      return (
                        <button className="card-btn">
                          <ReactSVG src={`images/paymentLogo/${logo.replace(/\s+/g, "")}.svg`} />
                          <div className="edit-cards-description">
                            <div className="description-section">
                              <p
                                className={`${
                                  card.type === PAYMENT_METHODS.CREDIT_CARD ? "" : "card-email"
                                }`}
                              >
                                {card.type === PAYMENT_METHODS.CREDIT_CARD
                                  ? `${card.cardholder_name ? card.cardholder_name : ""}`
                                  : `${card.email}`}
                              </p>
                              &nbsp;
                              <div className="card-last-digit">
                                <p className="dot-input">{card.last_4}</p> &nbsp;
                                {card.last_4}
                              </div>
                            </div>
                            <div className="checkbox-label">
                              <input
                                type="radio"
                                id={card.token}
                                checked={card.isdefault ? true : false}
                                onClick={(e) => handleSetDefault(card)}
                              />
                              <label>{t("Set_default")}</label>
                            </div>
                          </div>
                          {!card.isdefault && (
                            <Image
                              src={DeleteIcon}
                              className="remove-card-btn"
                              onClick={(e) => handleRemoveCard(e, card)}
                            />
                          )}
                        </button>
                      )
                    })
                  : null}
                <button className="card-btn new-card-btn" onClick={handleOpen}>
                  <img src={AddCardIcon} className="add-new-img" />
                  {t("Add_new_card")}
                </button>
              </div>
            ) : (
              <TirePaymentLoading
                parentClassName="edit-cards-parent"
                showBtnShimmer={false}
                addNewCardBtn={true}
              />
            )}
          </div>
        </div>
      ) : null}
    </>
  )
}

function mapStateToProps(state, props) {
  let user = state.user
  let has_cc_info_saved = user.has_cc_info_saved

  let activeVehicle =
    user.vehicles &&
    user.vehicles.length &&
    user.vehicles.length > 0 &&
    user.vehicles.find((v) => v.id == user.activeVehicleId)
  let braintreePaymentMethods = state.paymentMethods.braintreePaymentMethods
  let order =
    activeVehicle &&
    activeVehicle.id &&
    ((user && user.active_orders) || []).find((o) => o.vehicle_id === activeVehicle.id)

  let cart
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  }

  return {
    user: user,
    has_cc_info_saved: has_cc_info_saved,
    braintreePaymentMethods: braintreePaymentMethods,
    navOpen: state && state.leftnav && state.leftnav.navOpen,
    anyOrderServiceLackPrice: cart && cart.any_order_service_lacks_price
  }
}

export default connect(mapStateToProps, {
  getBraintreePaymentToken,
  createPaymentMethod,
  removePaymentCard,
  setDefaultPaymentCard,
  getPaymentCards
})(withTranslation("tirePayment")(TirePayment))
